// constant Project Information

const strings = {
  projectName: 'Red Carpet',
  version: '1.0.0',
  logoUrl: 'https://techholding.co/th-logo.png',
  userName: 'John Doe',
  userImageUrl:
    'https://e7.pngegg.com/pngimages/799/987/png-clipart-computer-icons-avatar-icon-design-avatar-heroes-computer-wallpaper.png',
  userEmail: 'john.doe@techholding.co',
};

const urlKeys = {
  location: 'location',
  skills: 'skills',
  status: 'status',
  capacity: 'capacity',
  sort: 'sort',
  search: 'search',
  sortBy: 'sortBy',
  clients: 'clients',
  filter: 'filter',
};
// constant values for employees page
const employeesPageStrings = {
  title: 'Employees',
  subtitle: 'Manage all your full-time & contractor employees.',
  addButtonText: 'ON-BOARDING EMPLOYEE',
  OffBoardingButtonText: 'COMPLETE OFF-BOARDING',
  searchBarPlaceholder: 'Search ID, Name & Job Title',
  filterButtonText: 'Filter',
  idColumnnIndex: 0,
  customNoDataStrings: {
    title: 'No Employee added',
    subtitleOne: "We don't have any employee's yet.",
    subtitleTwo: 'Start adding employees now.',
  },
  employeeAdded: 'Employee Added Successful',
  offBoardedStatus: 'offboarded',
  offBoardingStatus: 'offboarding',
};
const basicInformationStrings = {
  title: 'Basic Details',
  steps: 'Step 1/2',
  preSelectedSoftwares: ['Gusto', 'Keka', 'Harvest', 'Slack', 'GSuite'],
  placeHolder: {
    company_email: 'Work Email',
    first_name: 'First Name',
    last_name: 'Last Name',
    country_code: 'Country Code',
    phone_number: 'Phone Number',
    personal_email: 'Secondary Email',
    address: 'Address',
    location: 'Branch',
    city: 'City',
    state: 'State',
    zipcode: 'Zipcode',
  },

  menuItem: {
    MobileNumMenuItem: ['+01', '+52', '+91'],
  },
};

// add employee strings
const addEmployeeStrings = {
  title: 'On-boarding Employee',
  basicInfoPageSuccessButtonText: 'Next',
  jobInfoPageSuccessButtonText: 'Submit',
  basicInfoPageFailureButtonText: 'Cancel',
  jobInfoPageFailureButtonText: 'Back',
  stepOneLabel: 'Basic Details',
  stepTwoLabel: 'Job Details',
  stepThreeLabel: 'Softwares',
  hardwareTableHeader: 'Select Required Hardware',
  softwareTableHeader: 'Select Required Software',
  errorMessages: {
    required: 'Required *',
    minLengthPhoneNo: 'Minimun 10 digits required *',
    invalidZipcode: 'Invalid zipcode',
    invalidEmail: 'Invalid email format',
    invalidPhoneNo: 'Invalid phone number',
    invalidId: 'Invalid id',
    personal_email: 'Please enter personal email',
    invalidDate: 'Invalid date',
  },
  activeStatus: 'active',
  preSelectedSoftwares: ['Gusto', 'Keka', 'Slack', 'Harvest', 'Gsuite'],
  softwareTableData: [
    {
      id: 1,
      logo: 'https://play-lh.googleusercontent.com/OiG-QsKPm--v-16z225UtUND2IIbinlLrnBhSRch9kL_ruBCIh4GDA0sD_BnUPF93Ew=w480-h960-rw',
      name: 'Keka HR',
      isSelected: true,
    },
    {
      id: 2,
      logo: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAh1BMVEX////0XUj0YUz0Uzv0WUP0W0b0WELzTjT0Vj/6xb/zTDLzUTj0VT3zUjnzSi/82NT94N36ubL4p57+7Or95+X2iHv3kYX4m5H2g3X1bVv70Mv0ZFD+8e/3l4z++Pf5s6v2eWn4oZf6w732e2v1cmL70s75tq/5rKT4n5X1blz2gHL3jYD7y8WhrABpAAAGmUlEQVR4nO2dbXfiKhCAo0CI5M1oorWm0ap91f//+67adWvXgUA3dzP0zPOxp+TwCAJhBgwCgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiAIgiB+KM20HI/HZd13Pf4PytHkbpkq+YESu4di3HeduqPeVJFkEReD3wgeMplWo+bq30YgvdXamqbYZSy8krvSDFk2+2xJyW5Jox6rbsV4JhmH7C6EantxhD4GMey1+q3kWxWa9M5wVX2MPP4ZlltlbL6rdtyc/t87w3lm53dCVscCwi/D+zCx9jsSLWvPDB8UOHrq4Uk99MiwXjo14C+XIfjXvl1A8tj+G3glA3v3LQOxyRx7qEkbo+Eq68wPp+FKdSiI0bDoVBCh4aHLLorRcNxtC+IzbKLuRlGchuv2Nwm/DVdx14LIDMv2UUbwMIpCDq2xfTDcmddqIkrVYD2bv86rHZPMrkOjMtwY+2goxePT575TuakyZtGSqAxNFQ5Vld8U2CziVkdMhi/6FyahqhIsc1gyfwwbfXtE4rb9Lry0vIcgMtQ3Ybw3lSuHxiEHkSG853ske2kpuY68MBylOsFNa9mtYcsDj+FaMxfKwqawvqOiMaw1yxn2alV8qR1u0Bg+wx2N7+yKT7XrPTSG8IJNSNtQaKH7GmMxbCTcR1fWT3jTfI+xGB7AJnCpXa7ZHMBi+AhOaax9ovhkCzciFsMdNBaKxOURT/CbCRZDsHbRxOkZmkA4DsMSHGikW64F3NORGN5DA40Qbg/JwY6AxLCA3vJC4ysFANgRkBhOoA6WPDs+5Q0crnAYzqGVc/rk+JQZ9BQkhnuobhLeuNAD9gQkhnfQbG29Jr0Art4xG6qmveAXwPGKDP8RcC+dOj5lhbiXgiNN7Jo+Ci5qkBi+QnVjB8enVFBPQGII7pUmbbuIfwKlRGEx3EBjBH93e0gNvgMjMYQXzbHbQ0ZgCAOJIfzxp/dODwGHKyyGAZig4PhyAW/UYDF8BzdZMpc5H5zv8RjCgSenbQw4NRGNITzUDKR9I2qaEI1hkIItEM5syzeJJnKBxrCCo0fK9i14r4shojGEJ7OBSOz66QiOCmAyDDTBI7vgkyHfD48huMlyJLlrLzs15KngMcx1/YxVbUWn2hQAVIbBQlfNZG0umBvThhAZjrQ5XyE3vQu3JNQgMjTF4jNtNH/81pIUhcnwoB3xjz01AjfAp7PWw22YDPXfxFNFWfz4Z1893GXtGZioDMfGBFoRyeF8NP5YAdT5cxWnNkeHUBkGD6b0rbMkk/K4AA1TGSfcLk0Yl2FgU2sh7FOg8RnmHR8nwWcYTNoSYr03DLZdH7hAZ9iA27o/yTCo25PTPTcMStmpIkLDYNypIkbDbhVRGgbTwbdGVMxZX3/S7L4xLybviKNrt8ydD6ynDzniOD7AveXZtAvxTJMdh9YwaCqXmzHUoy7/b9G3iIGnoc3xuxNcnWL+/hkGQRFaHTGU63P61AGMla97dmjjWbRdAiJY+Os6LzAy4JoN0AOHdaaLK50E0s89KjhLtXVDGQHT1UJB15kJztT26jo2MDcxfOiv4i7Um9lQxex8ivsEDyMm07viS/oiGKFzTIfvlSYvJvvtkidJslzvJ6Ob9FNwSzmxOfvmCXDKinPuGGLAycI9/w8xcATSOUsVMfBhhEHf1eoOMPtvwH2YDi2Bg3OJ/QlG7GgCrLH+rgLfgIMZIu27Xp2hCVtxi0wOPzhoEmqcTqFiRruL7JS/iZhad0OY8wE/pEy1V6DJnzGSPmljOcj3aGyZ6LfkYg9uK79Q6N6BcsM1SmL5T+v4VzRS7qBc2vG7aU9VevRqeJzPuVyuvh5mq4uFNO3D2d6LgoHyPJ+LRA0fiqeyrusyL+ZL1bKXqlxP2fbI7ysvRMji848/xJqfEriCebQFdW9I6dP3UZ9mCs1ZETOZ6wnUHll9J4tIeTQVGu7i08PmfVfbgbaERYgIfzjmk/IbVyeHPo0ybbe2QvChT2+FpuRvXQt6JfiNmSJaeCX44jxTsG3fdXaidu2jQvk0TQT64146uPRooj9hPp5wS7rzaKl2ZuE0U4TSvxjFi7Rfz/Cs8vEnA5t5ZvdjCVytfY311o9xa1qUiNSdr34nmmKhDClDIpJ84tsAc0P5sshSoLuKkEn++jP2tYN6NF/EMmWnn37gPAyjhEm5nG082m2yobwvJvN99V7t55PiMPZq/UkQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBEEQBHHhP+NTVoCB8KHkAAAAAElFTkSuQmCC',
      name: 'Gusto',
      isSelected: true,
    },
    {
      id: 3,

      logo: 'https://w7.pngwing.com/pngs/344/344/png-transparent-google-logo-google-logo-g-suite-google-text-logo-symbol-thumbnail.png',
      name: 'GSuite',
      isSelected: false,
    },
    {
      id: 4,
      logo: 'https://cdn.mos.cms.futurecdn.net/SDDw7CnuoUGax6x9mTo7dd.jpg',
      name: 'Slack',
      isSelected: false,
    },
    {
      id: 5,
      logo: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAhFBMVEX6XQD/+PH6UgD/+/b+y7H/8uf7cCr6WQD/+/T6ZQ3/6Nj7g07/9ez+1r76Zwb9roX9t5D7iVD8nGj///z+2sP6YQD+x6n6ah/8nGr8oW//5tP+0rf+3sn/7d/8r4f7ilL7dy78l2D9v5v7h0n7ciP8p3r6TQD7ejf9w6T7kln7fjz8n23hYBtpAAADZUlEQVR4nO3d2XKiQBSAYUKrp01wC+C+jNGMmcz7v99YJVszg7EUxnjq/y8hnuaL8cI0pZ5HRERERERERERERERERERERERERN88ET+tfCLr+uH/HF1Y8vrRF19CPHptJY0nxYvwfmxfT003V0+fJqOHxYP+fjtI1xw0TBRvNrcmLehky0l3Ng/S42F07WX4w/A0YtXN1+y8ZZNN2PLPPPz2ZL8w9imrnQlltyycsL3rheY04TkTynZl8iVNs0KJe4XFCkLZF6+iVqFsgsLvtGmhv3aABWHknKhVuHRGNyuUfdsBZkKZWud4jUJ5D53RDQvf3acwF/aaEy7c0c0K/VaFsPvclFAmK3fJ+whl8uwer1HYKb0w7iR8cZ9ChOeWQIjwthAivGQJhAhvCyHCS5ZAiPC2ECK8ZAmECG8LIcJLlkD46EL5qVvox4dZsj+gUijeehWGySSNQjlExT1WfUKJ584eqz5habY+oRxK+3P6hG/uaIXC8i6yOmG/tNWrTij9ACHCWkKIsDoFQqlIh/AI6VemQegfhtGqqmX/4YUi4ydTOl34wVVfHlwosnTvniz1+EK/V3qINqHMzgMVCKPKl6AOoRxKF65PuPnij/TxheUbw/UJBwgRIkSIECFChAgRIkSIEOFlQk+30CYfL6FXaD60C+1GudD0ksvVKrTtSfqfY51Cs8o//OXxhebv2kMv34N7fOHHoNw2/3wiFcKdX7mHr0Q4On9zBkKECBEiRKhQaMbaheEv5UK7TN8UqRV+6hbaYJq97VMoNCacf2YahcIg+tjl72sVCs3Qd9/2aRS6F44w+0GECGsKIcLqECKsK4QIq0OIsK4QIqwOIcK6QoiwOoQahemNp/cV2mV8uowGhIvTpHsL043Q+oVmXSXcnp90W2VhuG1MGOwr/krb/f8otMv0+moXZoPKQjNrElgS2na2EVq30ERxOtoVmkUTrjxHaNrZK6JmoTXRPhtdFFoz3jf6FB6FYXb/q10c8o3Ql+R4WBau0wdsvhLm99ja+aybj+4ExRNes8DjU5J+GWhrvStsFEpnnByeulcgo0Vy4vOLS+tnX236exQX9yAn6ei311HcsO9Y/o2u7le6StUXvVae+Kt8sFx4goiIiIiIiIiIiIiIiIiIiIiIiIi+X38AvFOcKityj1UAAAAASUVORK5CYII=',
      name: 'Harvest',
      isSelected: false,
    },
  ],
  requiredsoftwareData: [
    {
      id: 1,
      logo: 'https://play-lh.googleusercontent.com/OiG-QsKPm--v-16z225UtUND2IIbinlLrnBhSRch9kL_ruBCIh4GDA0sD_BnUPF93Ew=w480-h960-rw',
      name: 'Keka HR',
      isSelected: false,
    },
    {
      id: 2,
      logo: 'https://logos-world.net/wp-content/uploads/2021/02/Google-Cloud-Emblem.png',
      name: 'GCP',
      isSelected: false,
    },
    {
      id: 3,
      logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Adobe_Systems_logo_and_wordmark.svg/1477px-Adobe_Systems_logo_and_wordmark.svg.png',
      name: 'Adobe',
      isSelected: false,
    },
    {
      id: 4,
      logo: 'https://logowik.com/content/uploads/images/jira3124.jpg',
      name: 'Jira',
      isSelected: false,
    },
  ],
};
const allocationUser = {
  noUser: 'N/A',
};
const branches = {
  india: 'India',
  remote: 'Remote',
  usa: 'USA',
  maxico: 'Maxico',
};
const assignHardwareDrawerStrings = {
  title: 'Assign Hardware',
  successButtonText: 'Assign',
  failureButtonText: 'Cancel',
  categoryDropdownPlaceHolder: 'Category',
  notesPlaceholder: 'Notes',
  searchBarPlaceholder: 'Search hardware by key',
};

const assignSoftwareDrawerStrings = {
  title: 'Request Software',
  successButtonText: 'Request',
  failureButtonText: 'Cancel',
  chooseUserPlaceholder: 'Choose User',
  notesPlaceholder: 'Notes',
  softwareRequestSuccessMessage: 'Softwares Requested Successfully',
  noSoftwareFound: 'No Software Found',
};

const addSkillsModalStrings = {
  title: 'Add skills',
  successButtonText: 'Done',
  failureButtonText: 'Cancel',
  searchbarPlaceholder: 'Search for skills',
  skillNotFound: 'No pre-defined skills found',
  addedSkillsSuccess: 'Skills updated successfully',
  duplicateSkillsMessage: 'Duplicate skills not allowed *',
};

// constant values for hardwares page
const hardwaresPageStrings = {
  title: 'Hardware',
  subtitle: 'Manage all your company & client hardware.',
  filterButtonText: 'Filters',
  categories: 'Categories',
  addButtonText: 'Hardware',
  searchBarPlaceholder: 'Search by Name, Serial Key, Allocation',
  deleteButtonText: 'Delete Hardware',
  idColumnnIndex: 1,
  customNoDataStrings: {
    title: 'No Hardware available',
    subtitleOne: 'We don’t have any hardware added yet.',
    subtitleTwo: 'Start adding hardware now.',
  },
};

// constant values for priojects page
const projectsPageStrings = {
  title: 'Projects',
  subtitle: 'Manage all your company projects',
  addButtonText: 'Project',
  filterButtonText: 'Filter',
  searchBarPlaceholder: 'Search by Name, Manager, Lead',
  idColumnnIndex: 0,
};

// constant values for sign in page

const signinStrings = {
  signIn: 'Sign In',
  SignInText: 'Sign in with your Tech Holding google account.',
  SignInButtonText: 'Sign In with Google',
  loginFailedMessage: 'Login failed. Try Again',
};

// constant values for softwares page
const softwaresPageStrings = {
  title: 'Softwares',
  clientsFilterKey: 'clients',
  statusFilterKey: 'status',
  subtitle: 'Manage all your company & client software.',
  addButtonText: 'Software',
  searchBarPlaceholder: 'Search by Name',
  filterButtonText: 'Filter',
  idColumnnIndex: 1,
  softwareAdded: 'Software Added Successfully',
  managerRoleArray: ['owner', 'manager', 'hr manager'],
  status: 'active',
};

const userSettingsString = {
  title: 'System Users',
  subtitle: 'View all your system users. ',
  searchBarPlaceholder: 'Search ID, Name & Job Title',
  filterButtonText: 'Filter',
  roleArray: ['owner'],
  offBoardedStatus: 'offboarded',
  offBoardingStatus: 'offboarding',
};

const employeeDetailsPageStrings = {
  pageTabs: {
    profile: 'employee',
    software: 'softwares',
    // below code is commented for hiding hardware and projects.

    // hardware: 'Hardware',
    // projects: 'Projects',
  },
  responseMessage: {
    userOffBoardedSuccess: 'User OffBoarded Successfully',
    userUpdateSuccess: 'User updated successfully.',
  },
  employeeDetailsCard: {
    idLabel: 'ID',
    jobTitleLabel: 'Job Title',
    departmentLabel: 'Department',
    managerLabel: 'Manager',
    locationLabel: 'Branch',
    workAllocation: 'Capacity',
    status: 'Status',
    editEmplployeeTitle: 'Edit Basic Details',
    successButtonText: 'Save Details',
    failureButtonText: 'Cancel',
  },
  employeeStatus: {
    active: 'Active',
    pending: 'Pending',
    OffBoarding: 'Offboarding',
    OffBoarded: 'Offboarded',
  },
  profileTab: {
    basicDetailsTitle: 'Basic Details',
    jobDetailstitle: 'Job Details',
    teamDetailsTitle: 'Team Details',
    editButtonText: 'Edit',

    firstNameLabel: 'First Name',
    lastNameLabel: 'Last Name',
    phoneNoLabel: 'Phone Number',
    personalEmailLabel: 'Secondary/Personal Email',
    locationLabel: 'Branch',
    addressLabel: 'Address',

    idLabel: 'Employee Id',
    jobTitleLabel: 'Job Title',
    typeLabel: 'Employment Type',
    agencyNameLabel: 'Person Name (Agency)',
    agencyEmailLabel: 'Email Address (Agency)',
    agencyPhoneNumberLabel: 'Phone Number (Agency)',
    startDateLabel: 'Start Date',
    endDateLabel: 'End Date',
    capacityLabel: 'Capacity',
    jobDescription: 'Job Description',

    departmentLabel: 'Department',
    managerLabel: 'Manager',
  },
  hardwareTabStrings: {
    searchBarPlaceholder: 'Search by name or serial key',
    assignHardwareButtonText: 'Assign Hardware',
  },
  softwareTabStrings: {
    searchBarPlaceholder: 'Search by name',
    assignSoftwareButtonText: 'Request Software',
    lastUpdateTime: 'Last Updated at ',
    softwareFetchErrorMessage: 'Software fetch failed',
    emptyTableMessage: 'No Softwares Assigned',
  },
  projectsTabStrings: {
    searchBarPlaceholder: 'Search by name',
    assignProjectButtonText: 'Assign Project',
  },

  noSkillsTitle: 'Add employee skills',
  noSkillsSubTitle: 'Click the button above to add employee skills',

  checklistCardTitle: 'Checklist',
  historyCardTitle: 'History',
  historyCardSeeAllButtonText: 'View All',
  skillsCardTitle: 'Skills',
  addSkillButtonText: 'Add Skill',
  captionText: 'Upload documents on Keka',
  checklistSteps: [
    'Create Profile',
    'Collect Document',
    'Provide Welcome Kit',
    'Assign Hardware',
  ],
  checkListUpdateFailMessage: 'Checklist updation failed',
  error404Text: {
    title: 'User Not Found',
    subtitle: 'The user you requested could not be found!',
  },
};

const historyComponentStrings = {
  noHistoryErrorText: 'No History Found',
  loadingText: 'Loading...',
  drawerTitle: 'History',
};

const revokeSoftwareDrawerStrings = {
  title: 'Revoke Software',
  revokeButtonText: 'Revoke',
  cancelButtonText: 'Cancel',
  placeHolder: {
    notes: 'Notes',
  },
  softwareTitle: 'Jira',
  softwareSubtitle: 'Westfield',

  iconImageLink:
    'https://seeklogo.com/images/J/jira-logo-FD39F795A7-seeklogo.com.png',
  imageAltText: 'jira Logo',
  revoked: 'revoked',
  successmessage: 'Software revoked successfully.',
};

const completeAssignmentSoftwareDrawerStrings = {
  errorMessage: { required: { username: 'Username is required.' } },
  keys: {
    username: 'username',
    notes: 'notes',
  },
  title: 'Assign Software',
  AssignButtonText: 'Assign',
  cancelButtonText: 'Cancel',
  placeHolder: {
    notes: 'Notes',
    username: 'Username',
  },
  softwareTitle: 'Jira',
  softwareSubtitle: 'Westfield',

  iconImageLink:
    'https://seeklogo.com/images/J/jira-logo-FD39F795A7-seeklogo.com.png',
  imageAltText: 'jira Logo',
  active: 'active',
  successmessage: 'Software assigned successfully.',
};

const revokeProjectDrawerStrings = {
  title: 'Revoke Project',
  revokeButtonText: 'Revoke',
  cancelButtonText: 'Cancel',
  placeHolder: {
    notes: 'Notes',
  },
};

const revokeHardwareDrawerStrings = {
  title: 'Revoke Hardware',
  revokeButtonText: 'Revoke',
  cancelButtonText: 'Cancel',
  placeHolder: {
    enter: 'Serial Key',
    notes: 'Notes',
  },
};

const assignProjectDrawerStrings = {
  title: 'Assign Project',
  assignButtonText: 'Assign',
  cancelButtonText: 'Cancel',
  placeholder: {
    search: 'Search Name',
  },
  placeHolder: {
    allocation: 'Work Allocation',
    notes: 'Notes',
  },
  hours: 'Hrs',
};

// constant values for customDrawer
const customDrawerStrings = {
  anchor: 'right',
  successButtonText: 'Save',
  failureButtonText: 'Cancel',
  possibleAnchorValues: ['left', 'right', 'top', 'bottom'],
  defaultErrorMessage: 'Something went wrong. Please try again.',
  backButtonText: 'back',
};

const CustomFilledIconButtonString = {
  variant: 'contained',
  textTransform: 'none',
  disabledOpacity: '50%',
  defaultOpacity: '100%',
};

const CustomOutlinedIconButtonString = {
  variant: 'outlined',
  textTransform: 'none',
};

const customSearchBarStrings = {
  placeholder: 'Search',
  placeHolderForClients: 'Search Clients',
};

const customTableStrings = {
  noDataMessage: 'No Data Available.',
  rowsPerPageOptions: [5, 10, 20, 50, 100, { label: 'All', value: -1 }],
  sortOrder: {
    ascending: 'asc',
    decending: 'desc',
  },
  roleValues: [
    { id: 1, role: 'Owner' },
    { id: 2, role: 'HR Manager' },
    { id: 3, role: 'Manager' },
    { id: 4, role: 'Lead' },
    { id: 5, role: 'Employee' },
  ],
  tableCellDataTypes: {
    status: 'status',
    url: 'url',
    image: 'image',
    multiple: 'multiple',
    text: 'text',
    dropdown: 'dropdown',
    select: 'select',
    employeeName: 'employeeName',
    skills: 'skills',
    role: 'role',
    capacityText: 'capacityText',
    name: 'name',
    hardwareAllocation: 'hardwareAllocation',
    note: 'note',
    icon: 'icon',
    nameWithImg: 'nameWithImg',
    notesLink: 'notesLink',
    date: 'assignDate',
    actionButton: 'actionButton',
    manager: 'managers',
    avatar: 'avatar',
    allocation: 'allocation',
    softwareNameWithIcon: 'softwareNameWithIcon',
    nameWithManager: 'nameWithManager',
    client: 'client',
    employeeId: 'employeeId',
  },
  tableCellStatusValues: {
    activeArray: ['Active', 'Available', 'Assigned'],
    pendingArray: ['Pending'],
    OffBoardingArray: ['Offboarding', 'Issue Logged', 'Revoked', 'Inactive'],
    OffBoardedArray: ['Offboarded'],
  },
};

// customTextFiledStrings
const customTextFieldStrings = {
  variant: 'outlined',
  placeHolder: 'Enter Your Text',
  type: 'text',
};

const customRadioButtonStrings = {
  label: ['Available', 'Not Available'],
  clientValue: ['Clients'],
  statusValue: ['Active', 'Inactive'],
  type: ['clients', 'status'],
  FilterListLabels: ['Filter', 'CLEAR'],
  MenulistText: ['Clients', 'Status'],
};
const navBarStrings = {
  employeePageTabLabel: 'Employees',
  softwarePageTabLabel: 'Softwares',
  hardwarePageTabLabel: 'Hardware',
  projectsPageTabLabel: 'Projects',
};
const joiningInformationStrings = {
  title: 'Job details',
  steps: 'Step 2/2',
  contractText: 'Through Agency?',
  capacityText: 'hours/week',
  capacityInHours: 'Hrs',
  capacityInWeek: '/ Week',
  maxCapacity: 40,
  diviceText: 'Select required devices',
  placeHolder: {
    officeLocation: 'Branch',
    employee_id: 'Employee Id',
    job_title: 'Job Title',
    employment_type: 'Employee Type',
    agency_name: 'Name (Agency)',
    agency_email: 'Email Address (Agency)',
    agency_phone_number: 'Phone Number (Agency)',
    join_date: 'Start Date',
    end_date: 'End Date',
    capacity: 'Capacity',
    description: 'Job Description',
    // JobDescription: 'About Employee',
  },
  menuItem: {
    employementTypeMenu: ['Full-time', 'Contractor', 'Part-time'],
  },
  ignoreFields: ['prefix'],
};
const deviceCategoryStrings = {
  // need to fetch from baceknd
  imageUrl:
    'https://images.pexels.com/photos/249538/pexels-photo-249538.jpeg?auto=compress&cs=tinysrgb&w=800',

  categories: ['Laptop', 'Phone', 'Monitor'],
};
const onBoardingDrawerStrings = {
  branchError: 'Unable to retrieve branch data.',
};
const addHardwareStrings = {
  addTitle: 'Add Hardware',
  editTitle: 'Edit Hardware',
  placeHolder: {
    category: 'Select Category',
    serialKey: 'Serial Key',
    modelNo: 'Model No',
    name: 'Name',
    vendorName: 'Vendor Name',
    dateOfPurchase: 'Date of Purchase',
    location: 'Location',
    description: 'Description',
  },
  successButtonText: 'Submit',

  deviceCategoryMenuItem: ['Laptop', 'Desktop', 'Charger', 'Keyboard', 'Mouse'],
  sampleData: {
    category: 'Laptop',
    serialKey: 'A4R86GG848398',
    modelNo: 'Mac book',
    name: 'mac Book Pro',
    vendorName: 'Electronics shop',
    dateOfPurchase: '02/23/2023',
    location: 'Ahmendabad',
    description: 'Product description',
  },
  intialData: {
    category: '',
    serialKey: '',
    modelNo: '',
    name: '',
    vendorName: '',
    dateOfPurchase: '',
    location: '',
    description: '',
  },
};

const projectDetailsPageStrings = {
  pageTitleText: 'Red Carpet',
  pageSubtitleText: 'Added: Feb 02, 2023    Last Edited: 4 hours ago',
  detailsTitleText: 'Details',
  editButtonText: 'Edit',
  detailsCard: {
    noOfEmployeesLabel: '# of employees',
    managerLabel: 'Manager',
    leadLabel: 'Lead',
    durationLabel: 'Duration',
    typeLabel: 'Type',
    descriptionLabel: 'Description',
  },
};

const hardwareDetailsPageStrings = {
  pageTitleText: 'Apple  Macbook Pro - 16 Inch 2023',
  pageSubtitleText: 'Added: Feb 02, 2023    Last Edited: 4 hours ago',
  detailsTitleText: 'Details',
  editButtonText: 'Edit',
  deleteButtonText: 'Delete',
  detailsCard: {
    categoryLabel: 'Category',
    serialKeyLabel: 'Serial Key',
    modelNoLabel: 'Model No',
    dateOfPurchaseLabel: 'Date of Purchase',
    locationLabel: 'Location',
    venderNameLabel: 'Vendor Name',
    descriptionLabel: 'Description',
  },
};
const softwareDetailsPageStrings = {
  pageTitleText: 'Jira',
  pageCompanyName: 'Company',
  pageTitleImageUrl:
    'https://play-lh.googleusercontent.com/_AZCbg39DTuk8k3DiPRASr9EwyW058pOfzvAu1DsfN9ygtbOlbuucmXaHJi5ooYbokQX',
  pageSubtitleText: 'Added: Feb 02, 2023      Last Edited: 4 hours ago',
  detailsTitleText: 'Details',
  editButtonText: 'Edit',
  deleteButtonText: 'Mark As',
  activeStatus: 'active',
  inactiveStatus: 'inactive',
  snackbarSuccessText: 'Software Updated Successfully',
  snackbarSuccessTextForEdit: 'Software Edited Successfully',
  confirmModalText: 'Are you sure you want to mark this software as ',
  modalFailureButtonText: 'cancel',
  detailsCard: {
    urlLabel: 'URL',
    nameLabel: 'Name',
    managerLabel: 'Manager',
    statusLabel: 'Status',
    clientLabel: 'Client',
    descriptionLabel: 'Description',
  },
  error404Text: {
    title: 'Software Not Found',
    subtitle: 'The software you requested could not be found!',
  },
};
const deleteHardwareStrings = {
  title: 'Delete Hardware',
  name: 'Apple  Mackbook Pro - 16 Inch 2023',
  serialNumberLabel: 'Serial Number : ',
  serailNumber: 'C02DW1G6MD6M',
  notes: 'Notes',
  successButtonText: 'Delete',
};

const tableCellStrings = {
  colon: ':',
  dash: '-',
  capacityHoursPostfix: 'Hours /',
  capacityweekPostfix: 'week',
};
const approveEmployeeStrings = {
  title: ' On-boarding Employee Request',
  errorMessage: 'Approve Employee Request failed',
  notAuthorized: 'Not Authorized to access this page',
  successButtonText: 'Approve',
  requireSoftwareText: 'Required Softwares',
  backButtonText: 'BACK TO EMPLOYEES',
  requireHardwareText: ' Required hardwares',
  noSoftwareText: 'Not requested any Software',
  openModal: {
    successMessage: 'Employee approved successfully',
    offboardSuccessMessage: 'Off-boarding complete!',
    buttonText: 'Ok',
  },

  assignTeam: 'Assign Team',
  selectDepartment: 'Select Department',
  assignManager: 'Assign Manager',
  assignProject: 'Assign Project (Optional)',
  departmentMenuItem: ['department1', 'department2', 'department3'],
  basicDetailsTitle: ' Basic Details',
  joinDetailsTitle: 'Job Details',
  managerMenuItem: ['Manager1', 'Manager2', 'Manager3'],
  projectMenuItem: ['Project1', 'Project2', 'Project3'],
  error404Text: {
    title: 'User Not Found',
    subtitle: 'The user you requested could not be found!',
  },
};
const employeeSoftwareDetailsStrings = {
  title: 'Jira',
  subtitle: 'Westfiled',
  // revokeButtonText: 'revoke',
  anchorDirection: 'right',
  iconImageLink:
    'https://seeklogo.com/images/J/jira-logo-FD39F795A7-seeklogo.com.png',
  imageAltText: 'jira Logo',
  ownership: 'Ownership',
  revoke: 'Revoke',
  notesLabel: 'Notes',
  notesText: ' Some important note which is is related to the above content.',

  cancelButtontext: 'Cancel',

  tableData: [
    {
      name: 'Project1',
    },
    {
      name: 'Project2',
    },
    {
      name: 'Project3',
    },
    {
      name: 'Project4',
    },
  ],
  tableHeadCell: [
    {
      id: 'project',
      dataType: 'name',
      label: 'Projects',
      flex: 1,
    },
  ],
};

const addProjectStrings = {
  editButtonText: 'Edit',
  submitButtonText: 'Submit',
  addTitle: 'Add Project',
  editTitle: 'Edit Project',
  placeHolder: {
    name: 'Name',
    duration: 'Duration',
    type: 'Type',
    manager: 'Manager',
    lead: 'Lead',
    description: 'Description',
  },

  durationTextFieldEndAdornment: 'Hrs',
  menuItem: {
    manager: ['Hardik Savaliya', 'Krishnal Jadav', 'Anuj Patel'],
    lead: ['Jared Cote', 'Nisarg Dsohi', 'Vishwa Patel'],
    type: ['Client', 'Internal'],
  },
};

const addSoftwareStrings = {
  editButtonText: 'Save',
  submitButtonText: 'Submit',
  failureButtonText: 'CANCEL',
  editTitle: 'Edit Software',
  addTitle: 'Add Software',
  menuItem: {
    ownership: ['Client', 'Company'],
    status: ['Active', 'Inactive'],
  },
  placeHolder: {
    url: 'URL',
    name: 'Name',
    status: 'Status',
    description: 'Description',
    manager: 'Manager',
    icon: 'Icon URL',
  },
  errorMessages: {
    required: 'Required *',
    invalidUrl: 'Invalid url',
    duplicateSoftware: 'Software already exists for this client',
  },
  addManagerButtonText: 'Add Manager',
  managerError: 'Failed to fetch users data.',
};

const deleteSoftwareStrings = {
  deleteButtonText: 'Delete',
  cancelButtonText: 'Cancel',
  deleteTitle: 'Delete Software',
  title: 'Miro',
  subtitle: 'Ownership: Company',
  placeHolder: {
    note: 'Note',
  },
};
const userRoles = {
  ownerRole: 1,
  hrManagerRole: 2,
  managerRole: 3,
  leadRole: 4,
  employeeRole: 5,
};

const pageNotFoundStrings = {
  buttonText: 'Redirect to Home page',
  pageSubtitle: 'The page you requested could not be found!',
};
const errorMessagePageStrings = {
  buttonText: 'Redirect to Home page',
  pageTitle: 'Something Went Wrong',
  pageSubtitle: 'An unknown error occured. Please try again after a while.',
};

const softwareNotesDrawerStrings = {
  title: 'Notes',
  assignDateLabel: 'Assign Date',
  data: {
    name: 'Jira - Westfiled',
    iconUrl:
      'https://seeklogo.com/images/J/jira-logo-FD39F795A7-seeklogo.com.png',
    userName: 'Guy Hawkins',
    userJobTitle: 'Software Engineer',
    assignDate: 'May 16, 2005',
    assignDateLabel: 'Assign Date',
    notes: [
      {
        action: 'Revoked',
        note: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.',
        timestamp: 'May 16, 2006',
      },
      {
        action: 'Assigned',
        note: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.',
        timestamp: 'May 16, 2007',
      },
      {
        action: 'Assigned',
        note: 'Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.',
        timestamp: 'May 16, 2008',
      },
    ],
  },
};

const offBoardEmployeeStrings = {
  clientNameTechholding: 'Techholding',
  submitButtonText: 'COMPLETE OFF-BOARDING',
  backButtonText: 'BACK',
  addTitle: 'Off - Boarding Employee',
  headerTitle: 'Name',
  sendRevokeButton: 'SEND REVOKE REQUEST',
  subTitle: 'Revoke Software :',
  listCancelButtonText: 'CANCEL',
  revokeButtonText: 'REVOKE',
  softwareMessage: 'No Softwares Available',
  allRevokeRequestButtonText: 'ALL REVOKE REQUEST',
  revokeRequestButtonText: 'SEND REVOKE REQUEST',
  isManagerText:
    'Please make sure to collect all the resources related to the above software.',
  notManagerText:
    'Send revoke request will send a notification mail to respected software manager.',
};

const employeeFilterDropdownStrings = {
  listItemName: ['Branch', 'Capacity', 'Skills', 'Status'],
  listItemType: ['location', 'capacity', 'skills', 'status'],
  CityList: [
    'Ahmedabad, India',
    'Pune, India',
    'Chennai, India',
    'Los Angeles, USA',
    'Hermosillo, Mexico',
  ],
  StatusList: ['Active', 'Pending', 'Offboarding', 'Offboarded'],
  dropDownTitle: ['Filter', 'CLEAR'],
  skillFetchError: 'Skill Fetch error',
  branchFetchError: 'Branches Fetch error',
};
const userSettingsFilterDropdownStrings = {
  listItemName: ['Status', 'Role'],
  listItemType: ['status', 'role'],

  StatusList: ['Active', 'Pending', 'Offboarding', 'Offboarded'],
  RoleList: ['Owner', 'HR Manager', 'Manager', 'Lead', 'Employee'],
  dropDownTitle: ['Filter', 'CLEAR'],
};

const softwareFilterDropdownStrings = {
  clientFetchError: 'Client Fetch error',
  clientNotFound: 'No such client found',
};

const employeeStatusStrings = {
  active: 'Active',
  OffBoarding: 'Offboarding',
  pending: 'Pending',
  OffBoarded: 'Offboarded',
};

const softwareStatusStrings = {
  active: 'Active',
  pending: 'Pending',
  revoked: 'Revoked',
};

const softwareStatusActionMessage = {
  revoke: 'Revoked By',
  active: 'Assigned By',
  pending: 'Requested By',
};

const onOffBoardButtonTextStrings = {
  approve: 'APPROVE EMPLOYEE',
  offBoard: 'OFF-BOARD EMPLOYEE',
  completeOffBoarding: 'COMPLETE OFF-BOARDING',
};

const navbarProfileMenuStrings = {
  logoutButtonText: 'logout',
  logoutText: 'Are you sure you want to Logout?',
  cancelButtonText: 'cancel',
};

const ownerRoleChangeString = {
  confirmButtonText: 'confirm',
  confirmTextFirst: 'Are you sure you want to change',
  confirmTextSecond: "'s role to owner ?",
  cancelButtonText: 'cancel',
};

const apiErrorComponentString = {
  defaultErroreMessage: 'Something went wrong.',
  refreshButtonText: 'Try Again',
};

const customModalString = {
  defaultErroreMessage: 'Something went wrong. Please try again.',
};

const daysToGoString = {
  noDateSelectedMessage: 'Last Date not selected yet',
  lastDateMessage: [
    'Last Date: ',
    ' Days to go',
    'Last Date was ',
    'No last date set',
    'EDIT',
    'Hours to go',
    'Year to go',
    'Off-boarding completed : ',
    'Employee Off-Boarded',
  ],
};

const offBoardEmployeePopupString = {
  successButtonText: 'OFF-BOARD',
  failureButtonText: 'CANCEL',
  popupMessage: ['Are you sure you want to discontinue ', ' as a employee?'],
  clearDateCalander: 'clear',
  DesktopDatePickerLabel: 'Last Date',
};

const actionButtonText = {
  assign: 'ASSIGN',
  revoke: 'REVOKE',
  resend: 'RESEND',
  revoked: 'REVOKED',
  reassign: 'REASSIGN',
  request: 'REQUEST',
};

const employeeAprrovalString = {
  status: {
    active: 'active',
    pending: 'pending',
    OffBoarding: 'Offboarding',
  },
};
const customHeadString = {
  skip: 'skip',
};

const completeAssignDrawerStrings = {
  title: 'Assign Software',
  logo: 'https://seeklogo.com/images/J/jira-logo-FD39F795A7-seeklogo.com.png',
  assignButtonText: 'Assign',
  cancelButtonText: 'Cancel',
  reAssignTitle: 'Re-Assign Software',
};

const softwareDetailsPageTopStrings = {
  addedSoftwareText: 'Added: ',
  lastEditSoftwareText: 'Last Edited: ',
};

const snackbarStrings = {
  variant: {
    success: 'success',
    error: 'error',
    warning: 'warning',
    info: 'info',
  },
  messages: {
    success: {
      allRevokeRequestInitiated: 'Revoke request initiated',
      mailSentSuccessfully: 'Mail sent successfully',
      roleUpdatedSuccessFully: 'Role Updated',
      softwareRequestSuccessFully: 'software requested successfully',
    },
    error: {
      somethingWentWrong: 'Something went wrong',
      emailNotificationFailed: 'Email notification failed for software request',
      userUnAuthorized: 'User Not Authorized',
      userNotFound: 'User Not Found',
      roleError: 'Role Update Failed',
      softwareRequestFail: 'Software request Failed',
    },
    warning: {
      tryAgainAfter: 'Please try again after {tryAfter} Hours',
      alreadySent: 'Revoke request has been already sent',
    },
  },
};

const momentStrings = {
  timeUnits: {
    hours: 'hours',
  },
  timeFormats: {
    timeOnly12HoursCycle: 'h:mmA',
  },
};

const branchString = {
  getAllBranch: '/branches',
};

const paginationStrings = {
  employeeListTable: 'employeeListTable',
  softwareListTable: 'softwareListTable',
  userSoftwareListTable: 'userSoftwareListTable',
  systemUsersListTable: 'systemUsersListTable',
};

const employmentTypes = {
  fullTime: 'Full-time',
  contractor: 'Contractor',
  partTime: 'Part-time',
};

const locations = {
  remoteIndia: 'Remote India',
  remoteUs: 'Remote US',
  remoteMexico: 'Remote Mexico',
};

export {
  customModalString,
  projectDetailsPageStrings,
  hardwareDetailsPageStrings,
  softwareDetailsPageStrings,
  pageNotFoundStrings,
  strings,
  navBarStrings,
  customDrawerStrings,
  customSearchBarStrings,
  customTableStrings,
  CustomFilledIconButtonString,
  CustomOutlinedIconButtonString,
  customTextFieldStrings,
  basicInformationStrings,
  addEmployeeStrings,
  employeesPageStrings,
  hardwaresPageStrings,
  projectsPageStrings,
  signinStrings,
  softwaresPageStrings,
  employeeDetailsPageStrings,
  revokeSoftwareDrawerStrings,
  revokeProjectDrawerStrings,
  revokeHardwareDrawerStrings,
  deviceCategoryStrings,
  joiningInformationStrings,
  addHardwareStrings,
  userSettingsString,
  deleteHardwareStrings,
  approveEmployeeStrings,
  employeeSoftwareDetailsStrings,
  assignProjectDrawerStrings,
  customRadioButtonStrings,
  addProjectStrings,
  addSoftwareStrings,
  deleteSoftwareStrings,
  addSkillsModalStrings,
  assignHardwareDrawerStrings,
  assignSoftwareDrawerStrings,
  softwareNotesDrawerStrings,
  offBoardEmployeeStrings,
  apiErrorComponentString,
  navbarProfileMenuStrings,
  employeeFilterDropdownStrings,
  daysToGoString,
  offBoardEmployeePopupString,
  historyComponentStrings,
  employeeStatusStrings,
  onOffBoardButtonTextStrings,
  softwareStatusStrings,
  actionButtonText,
  employeeAprrovalString,
  customHeadString,
  completeAssignDrawerStrings,
  softwareDetailsPageTopStrings,
  userSettingsFilterDropdownStrings,
  softwareFilterDropdownStrings,
  completeAssignmentSoftwareDrawerStrings,
  tableCellStrings,
  snackbarStrings,
  momentStrings,
  onBoardingDrawerStrings,
  branchString,
  errorMessagePageStrings,
  paginationStrings,
  ownerRoleChangeString,
  urlKeys,
  employmentTypes,
  locations,
  userRoles,
  branches,
  allocationUser,
  softwareStatusActionMessage,
};
